import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { termsOfUseHtml } from "@/lib/terms-of-use-html";

export const Route = createFileRoute("/terms-of-use")({
  head: () => ({
    meta: [
      { title: "Terms of Use & Disclosures | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair website terms of use and disclosures, including warranties, limitation of liability, intellectual property, and dispute resolution.",
      },
      { property: "og:title", content: "Terms of Use & Disclosures | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "Read the RESTORE® Hair terms of use covering site access, disclaimers, liability limits, and binding arbitration.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/terms-of-use/" }],
  }),
  component: TermsOfUsePage,
});

function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <section className="bg-background py-10 md:py-16">
          <div className="mx-auto max-w-4xl px-4">
            <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              Disclosures
            </h1>
            <div
              className="privacy-content mt-6 text-base leading-relaxed text-muted-foreground"
              dangerouslySetInnerHTML={{ __html: termsOfUseHtml }}
            />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}